import React, { useEffect, useState } from "react";
import Editor from "../Editor";
import axios from "axios";

const Evaluation = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [evalution, setEvalution] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // ✅ NEW

  const [form, setForm] = useState({
    title: "",
    description: "",
    seo_description: "",
    category_id: "",
  });

  const [mainImage, setMainImage] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const setEditorData = (data) => {
    setForm((prev) => ({ ...prev, description: data }));
  };

  const handleMainImageChange = (e) => {
    setMainImage(e.target.files[0]);
  };

  const handleImageGalleryChange = (e) => {
    const files = Array.from(e.target.files);
    setGalleryImages(files);
    const previews = files.map((file) => URL.createObjectURL(file));
    setPreviewImages(previews);
  };

  const resetForm = () => {
    setForm({
      title: "",
      description: "",
      seo_description: "",
      category_id: "",
    });
    setMainImage(null);
    setGalleryImages([]);
    setPreviewImages([]);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    resetForm();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("title", form.title);
    data.append("description", JSON.stringify([form.description]));
    data.append("seo_description", form.seo_description);
    if (form.category_id) data.append("category_id", form.category_id);
    if (mainImage) data.append("image", mainImage);
    galleryImages.forEach((file) => {
      data.append("image_gallery[]", file);
    });

    setIsLoading(true); // ✅ START LOADING
    try {
      const token = localStorage.getItem("token");
      await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/admin/academies`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      alert("Academy created successfully!");
      closeModal();
      fetchEvalution();
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong.");
    } finally {
      setIsLoading(false); // ✅ END LOADING
    }
  };

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${import.meta.env.VITE_API_BASE_URL}/api/admin/categories`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCategories(response.data);
    } catch (err) {
      console.error("Failed to fetch categories", err.response?.data || err.message);
    }
  };

  const fetchEvalution = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${import.meta.env.VITE_API_BASE_URL}/api/admin/academies`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setEvalution(response.data);
    } catch (err) {
      console.error("Failed to fetch evalution", err.response?.data || err.message);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchEvalution();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this evaluation?"
    );
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(
        `${import.meta.env.VITE_API_BASE_URL}/api/admin/academies/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      fetchEvalution(); // Refresh list
    } catch (error) {
      console.error("Delete failed:", error.response?.data || error.message);
      alert("Failed to delete the evaluation.");
    }
  };

  return (
    <div className="w-full flex flex-col gap-8">
      <div className="w-full flex flex-col gap-4 bg-[#00294B] rounded-md">
        <h2 className="px-4 pt-4 text-2xl font-bold text-white">Evaluation</h2>

        <div className="w-full flex items-center justify-end gap-4 border-b border-[#22BEFF33] px-4 pb-4">
          <button
            onClick={() => setIsModalOpen(true)}
            className="py-1 px-4 bg-[#22BEFF] text-black rounded cursor-pointer font-semibold"
          >
            Create
          </button>
        </div>

        <div className="w-full flex flex-col gap-4 p-4 min-h-[20rem]">
          {evalution.length === 0 ? (
            <h4 className="text-xl font-semibold text-white text-center">
              No Evalution found.
            </h4>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-[#022C4E] text-white rounded-md overflow-hidden">
                <thead>
                  <tr className="bg-[#00406B] text-left">
                    <th className="py-3 px-4">ID</th>
                    <th className="py-3 px-4">Image</th>
                    <th className="py-3 px-4">Name</th>
                    <th className="py-3 px-4">Category</th>
                    <th className="py-3 px-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {evalution.map((value) => (
                    <tr key={value.id} className="border-b border-[#1a3c5a]">
                      <td className="py-3 px-4">{value.id}</td>
                      <td className="py-3 px-4">
                        {value.image ? (
                          <img
                            src={`${import.meta.env.VITE_API_BASE_URL}/storage/${value.image}`}
                            alt={value.name}
                            className="w-16 h-16 object-cover rounded"
                          />
                        ) : (
                          <span className="text-gray-400">No Image</span>
                        )}
                      </td>
                      <td className="py-3 px-4">{value.title}</td>
                      <td className="py-3 px-4">{value.category.name}</td>
                      <td className="py-3 px-4">
                        <button
                          onClick={() => handleDelete(value.id)}
                          className="bg-red-600 hover:bg-red-700 text-white py-1 px-3 rounded"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          aria-modal="true"
          role="dialog"
        >
          <div className="bg-white p-6 rounded-md w-full max-w-2xl shadow-lg max-h-[90vh] overflow-auto">
            <h3 className="text-xl font-bold mb-4 text-black">Create Evaluation</h3>

            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <label>Title</label>
              <input
                type="text"
                name="title"
                value={form.title}
                onChange={handleInputChange}
                className="bg-[#143E55] p-3 rounded border border-[#22BEFF33] text-white"
                required
              />

              <label>Description</label>
              <Editor onChange={setEditorData} />

              <label>SEO Description</label>
              <textarea
                name="seo_description"
                value={form.seo_description}
                onChange={handleInputChange}
                className="bg-[#143E55] p-3 rounded border border-[#22BEFF33] text-white"
              />

              <label>Category</label>
              <select
                name="category_id"
                value={form.category_id}
                onChange={handleInputChange}
                className="bg-[#143E55] p-3 rounded border border-[#22BEFF33] text-white"
              >
                <option value="">-- Select Category --</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>

              <label>Main Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleMainImageChange}
                className="bg-[#143E55] p-3 rounded border border-[#22BEFF33] text-white"
              />

              <label>Image Gallery</label>
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={handleImageGalleryChange}
                className="bg-[#143E55] p-3 rounded border border-[#22BEFF33] text-white"
              />

              <div className="flex gap-2 flex-wrap">
                {previewImages.map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt="Preview"
                    className="w-20 h-20 object-cover rounded"
                  />
                ))}
              </div>

              <button
                type="submit"
                className={`bg-[#22BEFF] p-3 rounded-md mt-4 text-white font-bold ${
                  isLoading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isLoading}
              >
                {isLoading ? "Creating..." : "Create"}
              </button>
            </form>

            {/* Modal Footer */}
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={closeModal}
                className="py-1 px-4 bg-gray-300 text-black rounded"
                disabled={isLoading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Evaluation;
